import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { TimebandService } from 'src/app/angularJS/services/timebands/timeband.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';


export class ManageTimebandController {
  public static $inject = [
    'ACTToolbarService',
    'timeband',
    'breadcrumbService',
    'timebandService',
    'UserMessages',
    '$rootScope',
    '$state',
    'regexPatterns'
  ];

  public timebandApplications = [
    'USAGE_START',
    'USAGE_END',
    'USAGE_WITHIN',
    'USAGE_WITHOUT'
  ];

  public days = {
    'MONDAY': false,
    'TUESDAY': false,
    'WEDNESDAY': false,
    'THURSDAY': false,
    'FRIDAY': false,
    'SATURDAY': false,
    'SUNDAY': false,
    'SPECIAL': false
  };

  public form: any = {};

  constructor(
    private toolbarService: ACTToolbarService,
    public timeband: InterACT.Interfaces.Timebands.Timeband,
    private breadcrumbService: BreadcrumbService,
    private timebandService: TimebandService,
    private userMessagesService: UserMessagesService,
    private $rootScope: InterACT.Interfaces.IActoraRootScope,
    private $state: ng.ui.IStateService,
    public regexPatterns: { TIME: string, NUMBER: string }) {
    this.activate();
  }

  /**
   * A method that handles the case where a day has been selected/unselected
   * @param day the day that was selected/unselected
   */
  public onDaySelectionChanged = (day: string) => {

    if (!this.timeband.dayOfWeek) {
      this.timeband.dayOfWeek = [];
    }

    const indexOfDay = this.timeband.dayOfWeek.indexOf(<any>day);

    if (indexOfDay !== -1) {
      this.timeband.dayOfWeek.splice(indexOfDay, 1);
    } else {
      this.timeband.dayOfWeek.push(<any>day);
    }
  };

  /**
   * A method that posts the timeband on this controller to the services
   */
  public onSave = () => {
    let methodToCall: (timeband: InterACT.Interfaces.Timebands.Timeband) =>
      ng.IPromise<InterACT.Interfaces.Timebands.TimebandResponse |
        InterACT.Interfaces.Timebands.TimebandsResponse>;

    if (this.timeband.id) {
      methodToCall = this.timebandService.update.bind(this.timebandService);
    } else {
      methodToCall = this.timebandService.create.bind(this.timebandService);
    }

    this.$rootScope.showSpinner = true;
    methodToCall(this.timeband).then((response) => {
      this.$rootScope.showSpinner = false;
      this.userMessagesService.showToast('TIMEBAND_CREATED');
      this.$state.go('view-timebands');
    });
  };

  /**
   * A method that handles the case where the user has cancelled the creation/editing of a timeband
   */
  public onCancel = () => {
    this.$state.go('view-timebands');
  };

  /**
   * A method that is called during controller instantiation
   */
  private activate() {
    this.setSelectedDays();

    this.breadcrumbService.setBreadcrumbs([{
      name: 'ABT_CONFIGURATION',
      sref: '#'
    }, {
      name: 'PRODUCT_VALIDITY_TIMEBANDS',
      sref: 'view-timebands'
    }, {
      name: 'CREATE_TIMEBANDS',
      sref: '#'
    }]);

    this.toolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle(this.timeband.id ? 'EDIT_TIMEBANDS' : 'CREATE_TIMEBANDS');
    });
  }

  /**
   * A method that sets the selected state of each day of the week
   * using the days of the week that the timeband is active for
   */
  private setSelectedDays() {
    if (!this.timeband.dayOfWeek) {
      return;
    }

    for (let c = 0; c < this.timeband.dayOfWeek.length; c++) {
      this.days[this.timeband.dayOfWeek[c]] = true;
    }
  }
}